import { Host, h } from "@stencil/core";
import { convertObjectDataToSuggestData } from "./helpers";
import { renderSuggestLists } from "./renderSuggest";
export class ChTestSuggest {
    constructor() {
        this.objectsSuggestions = undefined;
        this.selectorSourceCallback = undefined;
    }
    // 5.EVENTS (EMIT) //
    // 6.COMPONENT LIFECYCLE EVENTS //
    // 7.LISTENERS //
    // 8.PUBLIC METHODS API //
    // 9.LOCAL METHODS //
    /**
     * This handler gets fired every time the value of the 'Select Object' ch-suggest changes.
     */
    selectObjectValueChangedHandler = async (e) => {
        const value = e.detail;
        this.selectorSourceCallback(value)
            .then(result => {
            /* show suggestions*/
            this.objectsSuggestions = convertObjectDataToSuggestData(result);
        })
            .catch(() => {
            // to do
        });
    };
    // 10.RENDER() FUNCTION //
    render() {
        return (h(Host, null, h("ch-suggest", { onValueChanged: this.selectObjectValueChangedHandler, part: "object-selector-suggest", exportparts: "dropdown:select-object-dropdown" }, renderSuggestLists(this.objectsSuggestions))));
    }
    static get is() { return "ch-test-suggest"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["test-suggest.css"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["test-suggest.css"]
        };
    }
    static get properties() {
        return {
            "selectorSourceCallback": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "(\n    prefix: string\n  ) => Promise<SelectorCategoryData[]>",
                    "resolved": "(prefix: string) => Promise<SelectorCategoryData[]>",
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        },
                        "SelectorCategoryData": {
                            "location": "local",
                            "path": "/home/runner/work/chameleon-controls-library/chameleon-controls-library/src/components/test/test-suggest/test-suggest.tsx",
                            "id": "src/components/test/test-suggest/test-suggest.tsx::SelectorCategoryData"
                        }
                    }
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": "Callback invoked when user writes on object selector input, return possible options to show in autocomplete list"
                }
            }
        };
    }
    static get states() {
        return {
            "objectsSuggestions": {}
        };
    }
}
//# sourceMappingURL=test-suggest.js.map
